module.exports = __webpack_public_path__ + "media/images/features/modification/bg-dotted-cec35063e71d2da2e8e7096abc584e7d.svg";